<ct-lib-modal [label]="'Release notes' | transloco" #modal>
  <ng-container
    *ngTemplateOutlet="releaseNote; context: { version: 'v2-10-0' }"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="releaseNote; context: { version: 'v2-9-0' }"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="releaseNote; context: { version: 'v2-8-0' }"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="releaseNote; context: { version: 'v2-7-0' }"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="
      releaseNote;
      context: { version: 'v2-6-0', bannerText: true }
    "
  ></ng-container>
  <hr />
  <div class="external-changelog">
    <a href="https://headwayapp.co/catch-talents-changelog" target="_blank"
      >{{ 'company-tool.snippets.release-notes-modal.link' | transloco }}
      <fa-icon [icon]="fontawesomeService.light.externalLink"></fa-icon>
    </a>
  </div>
</ct-lib-modal>

<ng-template #functionsTitle>
  <fa-icon [icon]="fontawesomeService.light.rocket"></fa-icon>
  {{ 'company-tool.snippets.release-notes-modal.title.functions' | transloco }}
</ng-template>

<ng-template #improvementsTitle>
  <fa-icon [icon]="fontawesomeService.light.stars"></fa-icon>
  {{
    'company-tool.snippets.release-notes-modal.title.improvements' | transloco
  }}
</ng-template>

<ng-template #fixesTitle>
  <fa-icon [icon]="fontawesomeService.light.bug"></fa-icon>
  {{ 'company-tool.snippets.release-notes-modal.title.fixes' | transloco }}
</ng-template>

<ng-template #dateTitle let-version="version">
  <fa-icon [icon]="fontawesomeService.light.calendarAlt"></fa-icon>
  {{
    'company-tool.snippets.release-notes-modal.' + version + '.date' | transloco
  }}
</ng-template>

<ng-template #releaseNote let-version="version" let-bannerText="bannerText">
  <div class="release-note">
    <div class="release-note-header">
      <div class="release-note-header-title sticky">
        <h2>
          <ng-container
            *ngTemplateOutlet="dateTitle; context: { version: version }"
          ></ng-container>
        </h2>
      </div>
      @if (bannerText) {
        <div class="release-notes-banner">
          <app-mesh-gradient
            [speed]="0.5"
            [seed]="69"
            [frequency]="{ x: 0.00014, y: 0.0029, delta: 0.001 }"
          ></app-mesh-gradient>
          <div class="release-notes-banner-content">
            <p>
              {{
                'company-tool.snippets.release-notes-modal.' +
                  version +
                  '.banner-text' | transloco
              }}
            </p>
          </div>
        </div>
      }
    </div>
    @if (
      getReleaseNoteSection(version, ReleaseNoteSection.FUNCTIONS);
      as functionsText
    ) {
      <div class="release-note-section has-sticky-header">
        <h3>
          <ng-container *ngTemplateOutlet="functionsTitle"></ng-container>
        </h3>
        <div class="release-note-text" [innerHTML]="functionsText"></div>
      </div>
    }
    @if (
      getReleaseNoteSection(version, ReleaseNoteSection.IMPROVEMENTS);
      as improvementsText
    ) {
      <div class="release-note-section has-sticky-header">
        <h3>
          <ng-container *ngTemplateOutlet="improvementsTitle"></ng-container>
        </h3>
        <div class="release-note-text" [innerHTML]="improvementsText"></div>
      </div>
    }
    @if (
      getReleaseNoteSection(version, ReleaseNoteSection.FIXES);
      as fixesText
    ) {
      <div class="release-note-section has-sticky-header">
        <h3>
          <ng-container *ngTemplateOutlet="fixesTitle"></ng-container>
        </h3>
        <div class="release-note-text" [innerHTML]="fixesText"></div>
      </div>
    }
  </div>
</ng-template>
